import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c504274&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./index.vue?vue&type=style&index=1&id=5c504274&lang=stylus&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c504274",
  null
  
)

export default component.exports